<!--
TODO: Add the control panel for the Duna
Create a table, and add the following columns:
- User ID
- User Name
- Unique ID
- Refresh Tokens
- Push Tokens
Table will be a syncfusion grid
-->
<div
  class="dynamic-table"
  [ngClass]="{ dense: settings.dense, 'mobile-mode': useCardLayout }"
>
  @if (getInput('tableTitle') || getInput('tableDescription')) {
  <div class="table-header-section">
    @if (getInput('tableTitle')) {
    <h2 class="table-title">{{ getInput("tableTitle") }}</h2>
    } @if (getInput('tableDescription')) {
    <p class="table-description">{{ getInput("tableDescription") }}</p>
    }
  </div>
  }

  <div class="table-controls">
    <div class="controls-top-row">
      @if (settings.searchable) {
      <mat-form-field class="search-field" appearance="outline">
        <mat-label>Søg</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          #searchInput
          [ngModel]="searchText"
          (ngModelChange)="onSearch($event)"
          (keydown.enter)="$event.preventDefault()"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          [attr.name]="searchInputName"
          [placeholder]="settings.searchPlaceholder || 'Søg i alle kolonner...'"
        />
        @if (searchText) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="clearSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
        }
      </mat-form-field>
      } @if (displayFilters.length) {
      <div class="filter-controls">
        @for (filter of displayFilters; track filter.column) {
        <div class="filter-chip">
          <span class="filter-chip__label">{{ filter.label }}</span>
          <mat-form-field
            appearance="fill"
            class="filter-chip__field"
            subscriptSizing="dynamic"
          >
            <mat-select
              [panelClass]="selectPanelClass"
              [value]="filter.value"
              [compareWith]="compareFilterValues"
              (selectionChange)="onFilterChange(filter, $event.value)"
            >
              <mat-option [value]="''">Alle</mat-option>
              @for (option of filter.options; track option.value) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
      </div>
      }

      <!-- Table options -->
      @if (settings.tableOptions?.length) {
      <div class="table-options">
        @for (option of settings.tableOptions; track option.id) { @switch
        (option.type) {
        <!-- Toggle option -->
        @case ('toggle') {
        <mat-slide-toggle
          [checked]="tableOptionsState[option.id]"
          (change)="onTableOptionChange(option, $event.checked)"
          class="table-option-toggle"
        >
          {{ option.label }}
        </mat-slide-toggle>
        }
        <!-- Select option -->
        @case ('select') {
        <mat-form-field class="table-option-select">
          <mat-label>{{ option.label }}</mat-label>
          <mat-select
            [panelClass]="selectPanelClass"
            [value]="tableOptionsState[option.id]"
            (selectionChange)="onTableOptionChange(option, $event.value)"
          >
            @for (opt of option.options; track opt.value) {
            <mat-option [value]="opt.value">
              {{ opt.label }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
        <!-- Button option -->
        @case ('button') {
        <button
          mat-raised-button
          (click)="onTableOptionChange(option, true)"
          class="table-option-button"
        >
          {{ option.label }}
        </button>
        } } }
      </div>
      }

      <!-- Print button -->
      @if (getInput('enablePrint')) {
      <button
        mat-icon-button
        (click)="printTable()"
        title="Udskriv tabel"
        class="print-button"
      >
        <mat-icon>print</mat-icon>
      </button>
      }
    </div>
  </div>

  @if (useCardLayout) {
  <div class="mobile-card-list">
    @for (row of (paginatedData$ | async); track trackMobileRow($index, row)) {
    <article
      class="mobile-card"
      [class.mobile-card--selected]="
        settings.multiSelect && selection.isSelected(row)
      "
      [class.mobile-card--no-data]="row.isNoDataRow"
      (click)="!row.isNoDataRow && onRowClick(row)"
    >
      <div class="mobile-card__inner">
        <!-- Header: avatar / checkbox + title + chevron -->
        <div class="mobile-card__header">
          @if (settings.multiSelect && !row.isNoDataRow) {
          <mat-checkbox
            class="mobile-card__checkbox"
            (click)="$event.stopPropagation()"
            (change)="$event ? toggleRowSelection(row) : null"
            [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
          >
          </mat-checkbox>
          } @if (!settings.multiSelect && !row.isNoDataRow) { @if
          (getMobilePrimaryColumn(); as pc) {
          <div class="mobile-card__avatar">
            {{ getColumnValue(row, pc) | slice : 0 : 2 }}
          </div>
          } }
          <div class="mobile-card__title-block">
            @if (getMobilePrimaryColumn(); as pc) {
            <div class="mobile-card__title">
              {{ getColumnValue(row, pc) }}
            </div>
            } @if (getMobilePrimarySubtitle(row); as sub) {
            <div class="mobile-card__subtitle">
              {{ sub }}
            </div>
            }
          </div>
          @if (!row.isNoDataRow && (settings.onRowClick ||
          getMobileActionColumns().length === 0)) {
          <mat-icon class="mobile-card__chevron"> chevron_right </mat-icon>
          }
        </div>
        <!-- Fields in a 2-column grid -->
        @if (!row.isNoDataRow && getMobileSecondaryColumns().length) {
        <dl class="mobile-card__fields">
          @for (column of getMobileSecondaryColumns(); track column.key; let i =
          $index) { @if (shouldShowMobileField(column, row)) {
          <div
            class="mobile-card__field"
            [class.mobile-card__field--full]="column.wrap"
          >
            <dt>{{ column.header }}</dt>
            <dd>{{ getColumnValue(row, column) }}</dd>
          </div>
          } }
        </dl>
        }
        <!-- Action buttons -->
        @if (getMobileActionColumns().length && !row.isNoDataRow) {
        <div class="mobile-card__actions" (click)="$event.stopPropagation()">
          @for (column of getMobileActionColumns(); track column.key) { @if
          (column.type === 'button' && (!column.showIf || column.showIf(row))) {
          @if (getButtonVariant(column, row) === 'flat') {
          <button
            mat-flat-button
            type="button"
            [color]="getButtonColor(column, row) || 'primary'"
            [ngClass]="getButtonClasses(column, row)"
            (click)="onActionClick(column, row)"
          >
            {{ getButtonLabel(column, row) }}
          </button>
          } @if (getButtonVariant(column, row) === 'raised') {
          <button
            mat-raised-button
            type="button"
            [color]="getButtonColor(column, row) || 'primary'"
            [ngClass]="getButtonClasses(column, row)"
            (click)="onActionClick(column, row)"
          >
            {{ getButtonLabel(column, row) }}
          </button>
          } @if (getButtonVariant(column, row) !== 'flat' &&
          getButtonVariant(column, row) !== 'raised') {
          <button
            mat-stroked-button
            type="button"
            [color]="getButtonColor(column, row) || 'primary'"
            [ngClass]="getButtonClasses(column, row)"
            (click)="onActionClick(column, row)"
          >
            {{ getButtonLabel(column, row) }}
          </button>
          } } @if (column.type === 'icon-button' && (!column.showIf ||
          column.showIf(row))) {
          <button
            mat-stroked-button
            type="button"
            [color]="column.buttonColor || 'primary'"
            (click)="onActionClick(column, row)"
          >
            @if (column.icon) {
            <mat-icon>{{ column.icon }}</mat-icon>
            }
            {{ column.buttonText }}
          </button>
          } @if (column.type === 'menu') { @for (item of
          getVisibleMenuItems(column, row); track item) {
          <button
            mat-stroked-button
            type="button"
            [style.color]="item.color || null"
            (click)="item.action(row)"
          >
            @if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
            }
            {{ item.label }}
          </button>
          } } }
        </div>
        }
      </div>
    </article>
    } @if (!(paginatedData$ | async)?.length) {
    <div class="mobile-empty-state">
      <mat-icon
        style="
          font-size: 36px;
          width: 36px;
          height: 36px;
          opacity: 0.35;
          display: block;
          margin: 0 auto 8px;
        "
      >
        table_rows
      </mat-icon>
      {{ noDataMessage }}
    </div>
    }
  </div>
  } @if (!useCardLayout) {
  <div class="table-scroll-wrapper">
    <table
      mat-table
      [dataSource]="(paginatedData$ | async) || []"
      matSort
      [matSortActive]="getCurrentSortColumn()"
      [matSortDirection]="getCurrentSortDirection()"
      [matSortDisableClear]="true"
      (matSortChange)="onSortChange($event)"
      [@fadeIn]
      [ngClass]="{
        striped: settings.striped,
        'table-layout-auto': settings.tableLayout === 'auto',
        'row-hover': settings.rowHover || settings.rowClickable
      }"
      style="transform: translateZ(0); will-change: contents"
    >
      <!-- Checkbox Column with fixed width -->
      @if (settings.multiSelect) {
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="select-column-header">
          <mat-checkbox
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="select-column-cell">
          @if (!row.isNoDataRow && row.participant_id !== 0 && row.name !== 'Der
          er endnu ingen data') {
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? toggleRowSelection(row) : null"
            [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
          >
          </mat-checkbox>
          }
        </td>
      </ng-container>
      } @for (column of settings.columns; track column.key) {
      <ng-container [matColumnDef]="column.key">
        @if (column.sortable !== false && settings.sortable &&
        !isButtonColumn(column)) {
        <!-- Sortable column header -->
        <th
          mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="column.key"
          [attr.data-sort-column]="column.key"
          [ngStyle]="getColumnWidthStyles(column)"
          [ngClass]="
            getColumnCellClasses(column, {
              'sortable-header': true,
              'sort-active': getCurrentSortColumn() === column.key
            })
          "
          [style.cursor]="'pointer'"
          [matTooltip]="column.header"
          [matTooltipDisabled]="false"
          matTooltipPosition="above"
        >
          {{ column.header }}
        </th>
        } @else {
        <!-- Non-sortable column header -->
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngStyle]="getColumnWidthStyles(column)"
          [ngClass]="getColumnCellClasses(column, { 'sortable-header': false })"
          [matTooltip]="column.header"
          [matTooltipDisabled]="false"
          matTooltipPosition="above"
        >
          {{ column.header }}
        </th>
        }
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="
            getColumnCellClasses(column, { clickable: !!settings.rowClickable })
          "
          [ngStyle]="getColumnWidthStyles(column)"
          [style.text-align]="column.alignment || 'left'"
          (click)="settings.onRowClick && settings.onRowClick(element)"
        >
          @switch (column.type) { @case ('button') { @if
          (!getButtonVariant(column, element) && !element.isNoDataRow &&
          (!column.showIf || column.showIf(element))) {
          <button
            mat-button
            [color]="getButtonColor(column, element) || 'primary'"
            [ngClass]="getButtonClasses(column, element)"
            [title]="getButtonLabel(column, element)"
            (click)="
              $event.stopPropagation(); onActionClick(column, element)
            "
          >
            {{ getButtonLabel(column, element) }}
          </button>
          } @if (getButtonVariant(column, element) === 'raised' &&
          !element.isNoDataRow && (!column.showIf || column.showIf(element))) {
          <button
            mat-raised-button
            [color]="getButtonColor(column, element) || 'primary'"
            [ngClass]="getButtonClasses(column, element)"
            [title]="getButtonLabel(column, element)"
            (click)="
              $event.stopPropagation(); onActionClick(column, element)
            "
          >
            {{ getButtonLabel(column, element) }}
          </button>
          } @if (getButtonVariant(column, element) === 'stroked' &&
          !element.isNoDataRow && (!column.showIf || column.showIf(element))) {
          <button
            mat-stroked-button
            [color]="getButtonColor(column, element) || 'primary'"
            [ngClass]="getButtonClasses(column, element)"
            [title]="getButtonLabel(column, element)"
            (click)="
              $event.stopPropagation(); onActionClick(column, element)
            "
          >
            {{ getButtonLabel(column, element) }}
          </button>
          } @if (getButtonVariant(column, element) === 'flat' &&
          !element.isNoDataRow && (!column.showIf || column.showIf(element))) {
          <button
            mat-flat-button
            [color]="getButtonColor(column, element) || 'primary'"
            [ngClass]="getButtonClasses(column, element)"
            [title]="getButtonLabel(column, element)"
            (click)="
              $event.stopPropagation(); onActionClick(column, element)
            "
          >
            {{ getButtonLabel(column, element) }}
          </button>
          } } @case ('icon-button') { @if (!element.isNoDataRow &&
          (!column.showIf || column.showIf(element))) {
          <button
            mat-icon-button
            [color]="column.buttonColor || 'primary'"
            [matTooltip]="column.buttonText || column.header"
            (click)="
              $event.stopPropagation(); onActionClick(column, element)
            "
          >
            <mat-icon>{{ column.icon || "more_horiz" }}</mat-icon>
          </button>
          } } @case ('menu') { @if (!element.isNoDataRow) {
          <button
            mat-icon-button
            [matMenuTriggerFor]="rowActionsMenu"
            (click)="$event.stopPropagation()"
            [title]="column.header || 'Handlinger'"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #rowActionsMenu="matMenu">
            @for (item of column.menuItems; track item.label) { @if (!item.showIf ||
            item.showIf(element)) {
            <button
              mat-menu-item
              (click)="onActionClick(item.action, element)"
              [style.color]="item.color || null"
            >
              @if (item.icon) {
              <mat-icon [style.color]="item.color || null">{{
                item.icon
              }}</mat-icon>
              }
              {{ item.label }}
            </button>
            } }
          </mat-menu>
          } } @case ('date') {
          {{
            column.format
              ? column.format(element[column.key])
              : isValidDate(element[column.key])
              ? (element[column.key] | date)
              : element[column.key]
          }}
          } @case ('boolean') {
          {{
            column.format
              ? column.format(element[column.key])
              : element[column.key]
              ? "Yes"
              : "No"
          }}
          } @case ('select') {
          <mat-form-field
            appearance="outline"
            class="table-select"
            (click)="$event.stopPropagation()"
          >
            <mat-select
              [panelClass]="selectPanelClass"
              [value]="element[column.key]"
              (selectionChange)="
                column.onChange && column.onChange($event.value, element)
              "
            >
              @for (option of column.options; track option.value) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @case ('component') {
          <!-- Render components based on componentName specified by data source -->
          @if (column.componentName === 'duna-validation-badge') {
          <span class="cell-badge-wrapper"
            ><app-duna-validation-badge
              [status]="
                column.componentInputs
                  ? column.componentInputs(element)['status']
                  : element[column.key]
              "
              [customTooltip]="
                column.componentInputs
                  ? column.componentInputs(element)['customTooltip']
                  : undefined
              "
            >
            </app-duna-validation-badge
          ></span>
          } @if (column.componentName === 'duna-educational-path-badge') {
          <span class="cell-badge-wrapper"
            ><app-duna-educational-path-badge
              [educationalPaths]="
                column.componentInputs
                  ? column.componentInputs(element)['educationalPaths']
                  : []
              "
              [currentYear]="
                column.componentInputs
                  ? column.componentInputs(element)['currentYear']
                  : getCurrentYear()
              "
            >
            </app-duna-educational-path-badge
          ></span>
          } @if (column.componentName === 'duna-user-progress-label') {
          <app-duna-user-progress-label
            [registeredPercentage]="
              column.componentInputs
                ? column.componentInputs(element)['registeredPercentage']
                : 0
            "
            [progressPercentage]="
              column.componentInputs
                ? column.componentInputs(element)['progressPercentage']
                : 0
            "
            [paths]="
              column.componentInputs
                ? column.componentInputs(element)['paths']
                : []
            "
            [totals]="
              column.componentInputs
                ? column.componentInputs(element)['totals']
                : null
            "
            [year]="
              column.componentInputs
                ? column.componentInputs(element)['year']
                : null
            "
            [showBreakdown]="
              column.componentInputs
                ? column.componentInputs(element)['showBreakdown'] ?? true
                : true
            "
            [compact]="
              column.componentInputs
                ? column.componentInputs(element)['compact'] ?? false
                : false
            "
            [aggregateContext]="
              column.componentInputs
                ? column.componentInputs(element)['aggregateContext'] ?? 'default'
                : 'default'
            "
          ></app-duna-user-progress-label>
          }
          <!-- Generic badge component -->
          @if (column.componentName === 'badge' && column.componentInputs) {
          <span
            class="badge-component"
            [matTooltip]="column.componentInputs(element)['tooltip'] || ''"
            [ngClass]="[
              'badge-' +
                (column.componentInputs(element)['color'] || 'default'),
              column.wrap ? 'wrap-text' : ''
            ]"
          >
            {{ column.componentInputs(element)["text"] || "" }}
          </span>
          }
          <!-- Generic icon component -->
          @if (column.componentName === 'icon' && column.componentInputs) { @if
          (column.componentInputs(element)['icon']) {
          <mat-icon
            [matTooltip]="column.componentInputs(element)['tooltip'] || ''"
            [ngClass]="
              'icon-' + (column.componentInputs(element)['color'] || 'default')
            "
          >
            {{ column.componentInputs(element)["icon"] }}
          </mat-icon>
          } }
          <!-- Add more components here as needed -->
          } @default {
          <!-- Special handling for registered_percentage column -->
          @if (column.key === 'registered_percentage') {
          <span
            [ngClass]="{
              'percentage-complete': element[column.key] === 100,
              'percentage-none': element[column.key] === 0,
              'percentage-partial':
                element[column.key] > 0 && element[column.key] < 100
            }"
          >
            {{
              column.transform
                ? column.transform(element[column.key], element)
                : column.format
                ? column.format(element[column.key])
                : element[column.key]
            }}
          </span>
          }
          <!-- Use a text input field for editable number columns (like maintenance_minutes) -->
          @if (column.editable && column.key.includes('minutes')) {
          <mat-form-field
            appearance="outline"
            class="table-input"
            (click)="$event.stopPropagation()"
          >
            <input
              matInput
              type="number"
              [ngModel]="element[column.key]"
              (ngModelChange)="
                column.onChange && column.onChange($event, element)
              "
            />
          </mat-form-field>
          }
          <!-- Regular text for non-editable or non-minute fields -->
          @if ((!column.editable || !column.key.includes('minutes')) &&
          column.key !== 'registered_percentage') {
          <span
            class="cell-text-line"
            [ngClass]="{
              'wrap-text': column.wrap,
              'clickable-cell': column.onClick,
              'cell-text-line--with-icon': !!getRowEventTypeIcon(element, column)
            }"
            [style.cursor]="column.onClick || settings.rowClickable ? 'pointer' : 'default'"
            [title]="column.tooltip ? column.tooltip(element) : ''"
            (click)="onCellClick($event, column, element)"
          >
            @if (getRowEventTypeIcon(element, column); as typeIcon) {
            <mat-icon
              class="cell-inline-type-icon"
              [matTooltip]="getRowEventTypeIconLabel(element, column)"
              >{{ typeIcon }}</mat-icon
            >
            }
            <span class="cell-text-line__value">{{
              getColumnValue(element, column)
            }}</span>
          </span>
          @if (column.subtitle && column.subtitle(element)) {
          <span class="cell-subtitle">
            {{ column.subtitle(element) }}
          </span>
          } } } }
        </td>
      </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{
          'no-data-row': row.isNoDataRow,
          'row-clickable': settings.rowClickable && !row.isNoDataRow
        }"
        [style.pointer-events]="row.isNoDataRow ? 'none' : 'auto'"
        (click)="onRowClick(row)"
      ></tr>
    </table>
  </div>
  }

  <!-- Batch edit footer with improved alignment -->
  @if (isBatchEditingAvailable()) {
  <div class="batch-edit-footer">
    <!-- Use a table with the same structure as the main table for perfect alignment -->
    <table class="batch-edit-table">
      <tr class="batch-edit-row">
        <!-- Same select column as the main table -->
        @if (settings.multiSelect) {
        <td class="select-column-cell"></td>
        }
        <!-- Only show non-module columns or module columns when visible -->
        @for (column of settings.columns; track column.key) { @if
        (!isModuleColumn(column) || isModuleColumnVisible()) {
        <td class="batch-edit-cell" [style.width]="column.width">
          @if (column.editable) { @if (column.editor === 'text') {
          <mat-form-field appearance="outline" class="batch-editor-field">
            <mat-label>{{ column.header }}</mat-label>
            <input
              matInput
              [(ngModel)]="batchUpdateValues[column.key]"
              [placeholder]="'Ændre ' + column.header"
              [type]="column.key.includes('minutes') ? 'number' : 'text'"
            />
          </mat-form-field>
          } @if (column.editor === 'select') {
          <mat-form-field appearance="outline" class="batch-editor-field">
            <mat-label>{{ column.header }}</mat-label>
            <mat-select
              [panelClass]="selectPanelClass"
              [(ngModel)]="batchUpdateValues[column.key]"
            >
              <mat-option [value]="null"
                >-- Vælg {{ column.header }} --</mat-option
              >
              @for (option of column.options; track option.value) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @if (column.editor === 'date') {
          <mat-form-field appearance="outline" class="batch-editor-field">
            <mat-label>{{ column.header }}</mat-label>
            <input
              matInput
              [(ngModel)]="batchUpdateValues[column.key]"
              type="date"
            />
          </mat-form-field>
          } @if (column.editor === 'boolean') {
          <mat-checkbox
            [(ngModel)]="batchUpdateValues[column.key]"
            class="batch-editor-checkbox"
          >
            {{ column.header }}
          </mat-checkbox>
          } }
        </td>
        } }
      </tr>
    </table>
    <div class="batch-edit-actions">
      <span class="selection-count"
        >{{ getTotalSelectedCount() }}
        {{ getTotalSelectedCount() === 1 ? "række" : "rækker" }} valgt</span
      >
      <button
        mat-raised-button
        color="primary"
        (click)="applyBatchUpdate()"
        [disabled]="
          !selection.selected.length ||
          isBatchUpdating ||
          !hasValidBatchValues()
        "
        [title]="!hasValidBatchValues() ? 'Vælg mindst én værdi at ændre' : ''"
      >
        @if (!isBatchUpdating) {
        <span>Anvend ændringer</span>
        } @if (isBatchUpdating) {
        <span>Anvender ændringer...</span>
        }
      </button>
      @if (settings.showRemoveButton && hasSelectedItems()) {
      <button
        mat-raised-button
        [color]="settings.removeButtonColor || 'warn'"
        (click)="onRemoveSelected()"
        [disabled]="!hasSelectedItems()"
      >
        {{ getRemoveButtonText() }}
      </button>
      }
      <button mat-stroked-button (click)="clearSelection()">Annuller</button>
    </div>
  </div>
  }

  <!-- Simple selection footer (just shows count and clear button) -->
  @if (settings.multiSelect && !isBatchEditingAvailable() &&
  (selection.selected.length > 0 || (persistSelections &&
  getPersistentSelectionsCount() > 0))) {
  <div class="simple-selection-footer">
    <div class="simple-selection-actions">
      <span class="selection-count"
        >{{ getTotalSelectedCount() }}
        {{ getTotalSelectedCount() === 1 ? "række" : "rækker" }} valgt</span
      >
      @if (settings.showRemoveButton && hasSelectedItems()) {
      <button
        mat-raised-button
        [color]="settings.removeButtonColor || 'warn'"
        (click)="onRemoveSelected()"
        [disabled]="!hasSelectedItems()"
      >
        {{ getRemoveButtonText() }}
      </button>
      }
      <button mat-stroked-button (click)="clearSelection()">Ryd valg</button>
    </div>
  </div>
  }

  <!-- Add space between the footer and paginator -->
  @if (settings.multiSelect && (selection.selected.length > 0 ||
  (persistSelections && getPersistentSelectionsCount() > 0))) {
  <div class="paginator-spacer"></div>
  }

  <!-- Custom pagination component to avoid z-index issues -->
  @if (settings.pageable) {
  <div class="custom-pagination">
    <div class="pagination-info">
      <span class="pagination-text">
        Viser {{ getPaginationStart() }} - {{ getPaginationEnd() }} af
        {{ getResultTotalCount() }} resultater
      </span>
    </div>
    <div class="pagination-controls">
      <!-- Page size selector -->
      <div class="page-size-selector">
        <label for="pageSizeSelect">Antal per side:</label>
        <select
          id="pageSizeSelect"
          [(ngModel)]="pageSize"
          (change)="onPageSizeChange($event)"
          class="custom-select"
        >
          @for (size of settings.pageSizeOptions || [5, 10, 25, 50, 100]; track
          size) {
          <option [value]="size" [selected]="size === pageSize">
            {{ size }}
          </option>
          }
        </select>
      </div>
      <!-- Navigation buttons -->
      <div class="pagination-navigation">
        <button
          mat-icon-button
          [disabled]="pageIndex === 0"
          (click)="
            onPageChange({
              pageIndex: pageIndex - 1,
              pageSize: pageSize,
              length: getResultTotalCount()
            })
          "
          class="nav-button"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="page-info">
          Side {{ pageIndex + 1 }} af {{ getTotalPages() }}
        </span>
        <button
          mat-icon-button
          [disabled]="pageIndex >= getTotalPages() - 1"
          (click)="
            onPageChange({
              pageIndex: pageIndex + 1,
              pageSize: pageSize,
              length: getResultTotalCount()
            })
          "
          class="nav-button"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Keep the original mat-paginator as fallback but hide it -->
  <mat-paginator
    [length]="getResultTotalCount()"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="settings.pageSizeOptions || [5, 10, 25, 50, 100]"
    (page)="onPageChange($event)"
    class="user-pagination"
    aria-label="Select page"
    style="display: none"
  >
  </mat-paginator>
</div>
